<template>
  <div class="subsidyList">
    <van-sticky>
      <div
        class="subsidyListNav"
        :style="{ 'padding-top': (isiOSX ? 44 : 24) + 'px' }"
      >
        <img
          class="navLeft"
          @click="goBack()"
          src="./../../../assets/decoration/back.png"
        />
        <span class="navTitle">每期记录</span>
      </div>
    </van-sticky>
    <div class="content">
      <van-sticky :offset-top="isiOSX ? 88 : 68">
        <div class="contentTop">
          <h3>每期记录</h3>
          <span @click="dataStatusPickerShow = true"
            >{{ dataStatusText }}
            <img src="./../../../assets/decoration/bottom.png" alt="" />
          </span>
        </div>
      </van-sticky>

      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <template #finished>
            <div class="finishedTip">
              <div v-if="dataList.length == 0">
                <img src="./../../../assets/decoration/noData.png" alt="" />
                <p>暂无相关数据</p>
              </div>
              <div v-else>没有更多了</div>
            </div>
          </template>
          <div class="midContent">
            <div
              class="card"
              @click="toSubsidyDetails(item.id)"
              v-for="(item, index) in dataList"
              :key="index"
            >
              <div class="item">
                <span class="blackBold">+{{ item.subsidy_amount }}</span>
                <span class="black" v-if="item.status_name == '已补贴' || item.status_name == '已退订'">{{
                  item.status_name
                }}</span>
                <span class="gray" v-else>{{ item.status_name }}</span>
              </div>
              <div class="item">
                <span>第{{ item.number }}期</span>
                <span v-if="item.status == 1"
                  >预计补贴日期：{{ item.subsidy_at | dateFormatting }}</span
                >
                <span v-if="item.status == 2"
                  >补贴日期：{{
                    item.subsidy_finished_at | dateFormatting
                  }}</span
                >
                <span v-if="item.status == 3"
                  >预计退订日期：{{ item.subsidy_at | dateFormatting }}</span
                >
                <span v-if="item.status == 4"
                  >退订日期：{{
                    item.subsidy_finished_at | dateFormatting
                  }}</span
                >
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <van-action-sheet v-model="dataStatusPickerShow" title="类型筛选">
      <div class="sheetContent">
        <p
          v-for="(item, index) in actions"
          :class="{ check: item.checkd }"
          :key="index"
          @click="onSelect(index)"
        >
          {{ item.name }}
        </p>
      </div>
    </van-action-sheet>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isiOSX: false,
      id: null,
      page: 1,
      pageSize: 10,
      loading: false,
      finished: false,
      refreshing: false,
      dataList: [],
      dataStatusPickerShow: false,
      status: 0,
      actions: [
        { name: "全部", value: 0, checkd: true },
        { name: "已退订", value: 4, checkd: false },
        { name: "未退订", value: 3, checkd: false },
        { name: "已补贴", value: 2, checkd: false },
        { name: "未补贴", value: 1, checkd: false },
      ],
      dataStatusText: "全部",
    };
  },
  filters: {
    dateFormatting(e) {
      if (e) {
        return e.substr(0, 10);
      }
    },
  },
  created() {
    this.isiOSX = this.isIphoneX();
    this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
    }
    this.getData();
  },
  mounted() {},
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    // 筛选
    onSelect(index) {
      this.actions.forEach((item) => {
        item.checkd = false;
      });
      this.actions[index].checkd = true;
      this.dataStatusText = this.actions[index].name;
      this.status = this.actions[index].value;
      this.dataStatusPickerShow = false;
      this.onRefresh();
    },
    // 获取订单列表
    getData() {
      this.loading = true;
      this.$api
        .post("decoration/member/order/subsidy/list", {
          pageSize: this.pageSize,
          page: this.page,
          order_id: this.id,
          status: this.status,
        })
        .then((res) => {
          // this.dataList = res.list;
          this.dataList = this.dataList.concat(res.list);
          this.loaded = true;
          this.refreshing = false;
          this.loading = false;
          if (this.dataList.length >= res.total) {
            // 数据全部加载完成
            this.finished = true;
          } else {
            this.finished = false;
          }
        })
        .catch((err) => {
          this.refreshing = false;
          this.loading = false;
          this.finished = true;
        });
    },
    // 下拉刷新
    onRefresh() {
      this.page = 1;
      this.dataList = [];
      this.getData();
    },
    // 上拉加载
    onLoad() {
      this.page++;
      this.getData();
    },
    // 跳转补贴详情
    toSubsidyDetails(id) {
      this.$router.push({
        path: "/decoration/order/subsidyDetails",
        query: {
          subsidy_id: id,
        },
      });
    },
  },
};
</script>
<style lang="less">
.subsidyList {
  min-height: 100%;
  background: #f5f6ff;
  .subsidyListNav {
    background: #ffffff;
    height: 44px;
    position: relative;
    .navLeft {
      width: 24px;
      height: 24px;
      position: absolute;
      left: 16px;
      bottom: 10px;
    }
    .navTitle {
      position: absolute;
      left: 50%;
      bottom: 10px;
      transform: translateX(-50%);
      font-size: 17px;
      font-weight: 700;
      color: #404247;
    }
  }
  .content {
    .contentTop {
      padding: 0 24px;
      background: #f5f6ff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      h3 {
        font-size: 15px;
        color: #333333;
      }
      span {
        background: #ffffff;
        border-radius: 13px;
        font-size: 13px;
        color: #999999;
        padding: 4px 16px;
        img {
          width: 12px;
        }
      }
    }
    .midContent {
      margin: -12px 16px 0;
      .card {
        background: #ffffff;
        border-radius: 8px;
        padding: 4px 16px 16px;
        margin-top: 12px;
        .item {
          display: flex;
          justify-content: space-between;
          margin-top: 12px;
          span {
            font-size: 13px;
            color: #999999;
            line-height: 18px;
          }
          .black {
            color: #333333;
          }
          .gray {
            color: #999999;
          }
          .blackBold {
            font-size: 16px;
            font-weight: bold;
            color: #333333;
            line-height: 22px;
          }
        }
      }
    }
  }
  .sheetContent {
    margin: 12px 0 55px;
    p {
      font-size: 16px;
      color: #333333;
      line-height: 22px;
      padding: 12px 0;
      text-align: center;
    }
    .check {
      color: #5853e9;
    }
  }
}
.finishedTip {
  img {
    width: 149px;
    height: 125px;
    margin-top: 64px;
  }
}
</style>